import React, { useState, useRef, useEffect } from 'react'
import Header from '../components/Header'
import classes from './MainApp.module.css'
import nextQuestion from '../logic/generator'
import Settings from '../settings/Settings'

let speachEnded = true

const MainApp = props => {
    const [data, setData] = useState({
        q: 'Tap here',
        positiveLong: 'Just click on white area!',
        positiveShort: 'Come on, you can do that!',
        negativeLong: 'Don\'t you understand what \'Tap here\' means?',
        negativeShort: 'Lol, here means there, not here!'
    })

    const answer = useRef()
    const border = useRef()

    const generate = () => {
        if (!speachEnded) {
            return
        }
        if (props.sound) {
            speachEnded = false
        }
        setData(nextQuestion)
        answer.current.innerHTML = ''
        border.current.style.border = ''
    }

    // prohibit rerender until the speech is pronounced + 
    useEffect(() => {
        if (!props.sound) {
            return
        }
        let finish = new SpeechSynthesisUtterance(data.q)
        window.speechSynthesis.speak(finish)
        finish.onend = () => speachEnded = true
    }, [data])

    const say = (msg) => {
        if (!speachEnded) {
            return
        }
        speachEnded = false
        let ans = new SpeechSynthesisUtterance(msg)
        window.speechSynthesis.speak(ans)
        ans.onend = () => speachEnded = true
    }


    return (
        <>
            {props.showSettings && <Settings onClose={props.onClose} sound={props.sound} soundOnOff={props.soundOnOff} />}
            <Header title='Drilleng' onClose={props.onClose} />
            <div className={classes.mainapp}>
                <div className={classes.questionblock} onClick={generate}>
                    <div className={classes.output}>
                        <h1>{data.q}</h1>
                    </div>
                    <p>tap here for next question</p>
                </div>
                <h4 style={{ marginTop: "10px" }}>CHECK YOUR ANSWER</h4>
                <div className={classes.checkblock}>
                    <div className={classes.halfblock}>
                        <h4 style={{ color: 'white' }}>NEGATIVE</h4>
                        <div className={classes.fullshort}>
                            <h4 onClick={() => {
                                if (!speachEnded) {
                                    return
                                }
                                answer.current.innerHTML = data.negativeLong;
                                props.sound && say(data.negativeLong)
                                border.current.style.border = "2px solid white"
                            }}>FULL</h4>
                            <h4 className={classes.lines} onClick={() => {
                                if (!speachEnded) {
                                    return
                                }
                                answer.current.innerHTML = data.negativeShort;
                                props.sound && say(data.negativeShort)
                                border.current.style.border = "2px solid white"
                            }}>SHORT</h4>
                        </div>
                    </div>
                    <div className={classes.halfblock}>
                        <h4 style={{ color: 'white' }}>POSITIVE</h4>
                        <div className={classes.fullshort}>
                            <h4 onClick={() => {
                                if (!speachEnded) {
                                    return
                                }
                                answer.current.innerHTML = data.positiveLong;
                                props.sound && say(data.positiveLong)
                                border.current.style.border = "2px solid white"
                            }}>FULL</h4>
                            <h4 className={classes.lines} onClick={() => {
                                if (!speachEnded) {
                                    return
                                }
                                answer.current.innerHTML = data.positiveShort;
                                props.sound && say(data.positiveShort)
                                border.current.style.border = "2px solid white"
                            }}>SHORT</h4>
                        </div>
                    </div>
                </div>
                <div className={classes.answerblock} ref={border}>
                    <h1 ref={answer}>{''}</h1>
                </div>
            </div>
        </>
    )
}

export default MainApp